//
// Copyright (c) 2023 Emplifi, Inc.
//

import { Plugin } from "ckeditor5";
import ResizeFigure from "./resizeFigure";
import AlignFigure from "./alignFigure";

export default class FigureTools extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  public static get pluginName() {
    return "FigureTools";
  }

  // noinspection JSUnusedGlobalSymbols
  public static get requires() {
    return [ResizeFigure, AlignFigure];
  }
}
